"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.util = exports.adjust = exports.model = exports.TrainerSim = exports.sim = exports.convert = void 0;
/**
 * v1's API (TrainerSim, convert) on the engine, as drop-in replacements:
 * `const { sim, convert, model } = compat` stands in for the package's
 * top-level namespaces. See docs/compat.md for what differs.
 */
exports.convert = __importStar(require("./convert"));
exports.sim = __importStar(require("./sim"));
var trainer_sim_1 = require("./trainer-sim");
Object.defineProperty(exports, "TrainerSim", { enumerable: true, get: function () { return trainer_sim_1.TrainerSim; } });
exports.model = __importStar(require("../models"));
exports.adjust = __importStar(require("../tableSpinAdjust"));
exports.util = __importStar(require("../util"));
